import { render, staticRenderFns } from "./leave-case-import-details.vue?vue&type=template&id=3ba10b8c&scoped=true"
import script from "./leave-case-import-details.vue?vue&type=script&lang=ts"
export * from "./leave-case-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba10b8c",
  null
  
)

export default component.exports